module.exports = __webpack_public_path__ + "static/media/73.41577daa.png";